import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'

import EventsComponent from './component'

export const EventsOverview = combine(
  withTableController({ id: 'events-table' }),
  withContext('appStore', StoreContext),
  withCallbacks(
    {
      // TODO: remove default value for search after amendments on BE
      loadEvents:
        ({ appStore }) =>
        async (tableState, _table, { search = '', inWinnable } = {}) => {
          const inWinnableParams = {}
          const sortByNewest = 'id,desc'
          if (inWinnable) {
            inWinnableParams.onlyManuallyNonInWinnable = inWinnable
            // inWinnableParams.startTimeEqOrGreater = new Date().getTime()
          }
          const { response, events } = await appStore.events.load({
            page: tableState.page,
            size: tableState.pageSize,
            sort: sortByNewest,
            matchNameSearch: search,
            ...inWinnableParams,
            onlyManuallyNonInWinnable: inWinnable,
          })

          return {
            ...response,
            content: events,
          }
        },

      onInwinableBet:
        ({ table }) =>
        () => {
          table.refresh()
        },

      onResolveBet:
        ({ table, appStore }) =>
        async ({ eventId, binaryWinner }) => {
          await appStore.inwins.resolveBinary(eventId, binaryWinner)
          table.refresh()
        },

      onSearch:
        ({ table }) =>
        (query) => {
          table.search(query)
        },
    },
    []
  )
)(EventsComponent)
